import React from 'react';
import loader from '../../../images/loader.gif';

import cl from './Loader.module.css';

const Loader = () => {
    return (
        <div className={cl.loader}>
            <img src={loader} alt="loader" className={cl.loader__image} />
        </div>
    )
}

export default Loader;